module.exports = __webpack_public_path__ + "static/img/11.73dc2f3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/10/sp/11.png
// module id = 5N3D
// module chunks = 0